import {useMutation, useQuery} from '@apollo/client';
import {GetRaces} from '../../../GraphQL/SystemQueries';
import React, {useEffect} from 'react';
import {useAppDispatch} from '../../../redux/hooks';
import {toast} from 'react-toastify';
import {setActiveContent, setIsAppLoading} from '../../../redux/slices/content/contentSlice';
import Button from '../../../Atoms/Button';
import {DeleteSharp, PlayArrowSharp} from '@mui/icons-material';
import {PopUp} from '../../../Atoms/PopUp';
import Input from '../../../Atoms/Input';
import {TextEditor} from '../../../Atoms/TextEditor';
import {
    CreateRace,
    CreateRaceFeature,
    DeleteRace, DeleteRaceFeature,
    UpdateRace,
    UpdateRaceFeature
} from '../../../GraphQL/SystemMutations';
import {ActiveContent} from '../../../redux/slices/content/contentType';
import {VeneList} from "../../../Atoms/VeneList";
import {Race, RaceFeature} from "../../../redux/slices/character/characterType";
import * as _ from "lodash";

export const emptyRace: Race = {
    raceId: 0,
    raceName: "",
    raceFeatures: [],
    raceDescription: ""
}

export const Voelker = () => {
    const dispatch = useAppDispatch();

    const [ races, setRaces ] = React.useState<Race[]>([]);
    const [ selectedRace, setSelectedRace ] = React.useState<Race>(emptyRace);
    const [ deleteRaceId, setDeleteRaceId ] = React.useState<number>(0)
    const [ isPopUpVisible, setIsPopUpVisible ] = React.useState<boolean>(false);
    const [ isDeletePopUpVisible, setIsDeletePopUpVisible ] = React.useState<boolean>(false);

    const {data: raceData, loading: raceLoading, error: raceError} = useQuery(GetRaces, {fetchPolicy: 'network-only'});
    const [ createRaceHook, {}] = useMutation(CreateRace);
    const [ updateRaceHook, {}] = useMutation(UpdateRace);
    const [ deleteRaceHook, {}] = useMutation(DeleteRace);

    const [ createRaceFeatureHook, {}] = useMutation(CreateRaceFeature);
    const [ updateRaceFeatureHook, {}] = useMutation(UpdateRaceFeature);
    const [ deleteRaceFeatureHook, {}] = useMutation(DeleteRaceFeature);

    useEffect(() => {
        if (raceData && !raceLoading) {
            setRaces(raceData.getRaces);
        }
    }, [ raceData ])

    useEffect(() => {
        if (raceError) {
            toast('Fehler beim Laden der Völker')
        }
    }, [ raceError ])

    useEffect(() => {
        if (raceLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Völker werden geladen...'}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ raceLoading ])

    const editRace = (race: any) => {
        setSelectedRace({
            raceId: race.raceId,
            raceName: race.raceName,
            raceDescription: race.raceDescription,
            raceFeatures: race.raceFeatures
        });
        setIsPopUpVisible(true)
    }

    const deleteRace = (race: any) => {
        setDeleteRaceId(race.raceId);
        setIsDeletePopUpVisible(true);
    }

    const handleUpdateRace = async () => {
        if (selectedRace) {
            const updateData = await updateRaceHook({
                variables: {
                    raceId: Number(selectedRace.raceId),
                    raceName: selectedRace.raceName,
                    raceDescription: selectedRace.raceDescription
                },
                refetchQueries: [{
                    query: GetRaces
                }]
            })

            if (!updateData.errors) {
                toast(`Das Volk: ${selectedRace.raceName} wurde gespeichert!`);
                setSelectedRace(emptyRace);
                setIsPopUpVisible(false);
            } else {
                toast(`Fehler beim Speichern des Volks: ${selectedRace.raceName}!`)
            }
        }
    }

    const handleCreateRace = async () => {
        if (selectedRace) {
            const createData = await createRaceHook({
                variables: {
                    raceName: selectedRace.raceName,
                    raceDescription: selectedRace.raceDescription
                },
                refetchQueries: [{
                    query: GetRaces
                }]
            })

            if (!createData.errors) {
                toast(`Das Volk: ${selectedRace.raceName} wurde erstellt!`);
                setSelectedRace(emptyRace);
                setIsPopUpVisible(false);
            } else {
                toast(`Fehler beim erstellen des Volks: ${selectedRace.raceName}!`)
            }
        }
    }

    const handleDeleteRace = async () => {
        const deleteData = await deleteRaceHook({
            variables: {
                raceId: Number(deleteRaceId),
            },
            refetchQueries: [{
                query: GetRaces
            }]
        })

        if (!deleteData.errors) {
            toast(`Das Volk wurde erfolgreich gelöscht!`)
        } else {
            toast(`Fehler beim Löschen des Volkes!`)
        }

        setDeleteRaceId(0);
        setIsDeletePopUpVisible(false);
    }

    const handleClosePopUp = () => {
        setSelectedRace(emptyRace);
        setIsPopUpVisible(false)
    }

    const deleteRaceFeature = async (raceFeatureId: number) => {
        await deleteRaceFeatureHook({
            variables: {
                raceFeatureId: Number(raceFeatureId)
            }
        })
    }

    const saveRaceFeature = async (raceFeature: RaceFeature) => {
        if (raceFeature.raceFeatureId > 0) {
            await updateRaceFeatureHook({
                variables: {
                    raceFeatureId: Number(raceFeature.raceFeatureId),
                    raceFeatureName: raceFeature.raceFeatureName,
                    raceFeatureDesc: raceFeature.raceFeatureDesc
                },
                refetchQueries: [{
                    query: GetRaces
                }]
            })
        } else {
            const response = await createRaceFeatureHook({
                variables: {
                    raceId: Number(selectedRace.raceId),
                    raceFeatureName: raceFeature.raceFeatureName,
                    raceFeatureDesc: raceFeature.raceFeatureDesc
                },
                refetchQueries: [{
                    query: GetRaces
                }]
            })

            if (!response.errors) {
                toast(`Feature gespeichert`);
                setSelectedRace(response.data.createRaceFeature)
            }
        }
    }

    const renderOneRaceFeature = (raceFeature: RaceFeature, index: number) => {
        return (
            <div className='abilityContainer mt-3'>
                <div className='row justify-content-end'>
                    <div className='col-2 text-end'>
                        <Button onClick={ async () => await deleteRaceFeature(raceFeature.raceFeatureId)}>
                            Löschen
                        </Button>
                    </div>
                    <div className='col-2 text-end'>
                        <Button onClick={ async() => await saveRaceFeature(raceFeature)}>
                            Speichern
                        </Button>
                    </div>
                </div>
                <Input label="Name" type="text" value={raceFeature.raceFeatureName} onChange={(e: any) => {
                    let updatedRaceFeature = _.cloneDeep(selectedRace.raceFeatures);
                    updatedRaceFeature[index].raceFeatureName = e.target.value;
                    setSelectedRace({
                        ...selectedRace,
                        raceFeatures: updatedRaceFeature
                    });
                }}/>
                <TextEditor label="Beschreibung" onChange={ (e) => {
                    let updatedRaceFeature = _.cloneDeep(selectedRace.raceFeatures);
                    if (e !== updatedRaceFeature[index].raceFeatureDesc) {
                        updatedRaceFeature[index].raceFeatureDesc = e;
                        setSelectedRace({
                            ...selectedRace,
                            raceFeatures: updatedRaceFeature
                        });
                    }
                }} value={raceFeature.raceFeatureDesc}/>
            </div>
        )
    }

    const renderAllRaceFeatures = () => {
        const raceFeatureHMTL = [];
        let index = 0;
        if (selectedRace) {
            for (const raceFeature of selectedRace.raceFeatures) {
                raceFeatureHMTL.push(renderOneRaceFeature(raceFeature, index));
                index++
            }
        }

        return raceFeatureHMTL
    }

    const addNewRaceFeature = () => {
        let updatedRaceFeatures = _.cloneDeep(selectedRace.raceFeatures);
        updatedRaceFeatures.push({
            raceFeatureId:   0,
            raceFeatureName: '',
            raceFeatureDesc: ''
        });
        setSelectedRace({
            ...selectedRace,
            raceFeatures: updatedRaceFeatures
        })
    }

    return (
        <div style={{ height: '95vh', overflowY: 'auto' }}>
            {(selectedRace.raceId !== 0 && isPopUpVisible) && (
                <PopUp onClose={handleClosePopUp} title='Volk bearbeiten'>
                    <div className='row justify-content-end'>
                        <div className='col-2'>
                            <Button onClick={ async () => selectedRace.raceId > 0? await handleUpdateRace() : await handleCreateRace() }>{selectedRace.raceId > 0 ? 'Speichern' : 'Erstellen'}</Button>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-12'>
                            <Input label='Name' value={selectedRace.raceName} onChange={(e) => setSelectedRace({
                                ...selectedRace,
                                raceName: e.target.value
                            })}/>
                        </div>
                        <div className='col-12'>
                            <TextEditor label='Beschreibung' value={selectedRace.raceDescription} onChange={(value) => setSelectedRace({
                                ...selectedRace,
                                raceDescription: value
                            })}/>
                        </div>
                    </div>
                    { selectedRace.raceId > 0 &&
                        <div>
                            <Button onClick={ () => addNewRaceFeature() }>+ Feature</Button>
                            { renderAllRaceFeatures() }
                        </div>
                    }
                </PopUp>
            )}
            {(selectedRace.raceId === 0 && !isPopUpVisible) && (
                <div>
                    { isDeletePopUpVisible && (
                        <PopUp onClose={setIsDeletePopUpVisible} title='Volk löschen'>
                            <div className='row mt-3 justify-content-center'>
                                <div className='col-12'>
                                    <b>Sind sie sicher, dass sie das Volk löschen möchten?</b>
                                </div>
                                <div className='col-2'>
                                    <Button onClick={ async() => await handleDeleteRace() }>Löschen</Button>
                                </div>
                                <div className='col-2'>
                                    <Button onClick={() => {
                                        setDeleteRaceId(0);
                                        setIsDeletePopUpVisible(false)
                                    }}>Abbrechen</Button>
                                </div>
                            </div>
                        </PopUp>
                    )}
                    <div className='row justify-content-between'>
                        <div className='col-2'>
                            <Button onClick={() => dispatch(setActiveContent(ActiveContent.Standardinhalte))}>
                                Zurück
                            </Button>
                        </div>
                        <div className='col-2'>
                            <Button onClick={() => {
                                setSelectedRace({
                                    raceId: -1,
                                    raceName: '',
                                    raceDescription: '',
                                    raceFeatures: []
                                })
                                setIsPopUpVisible(true)
                            }}>
                                Hinzufügen
                            </Button>
                        </div>
                    </div>
                    <VeneList<Race>
                        data={races}
                        colDefinition={[
                            {
                                colName: "ID",
                                keyName: "raceId",
                            },
                            {
                                colName: "Name",
                                keyName: "raceName"
                            }
                        ]}
                        buttonConfig={[
                            {
                                icon: <PlayArrowSharp/>,
                                onClick: (dataEntry) => {editRace(dataEntry)}
                            },
                            {
                                icon: <DeleteSharp/>,
                                onClick: (dataEntry) => {deleteRace(dataEntry)}
                            }
                        ]}
                    />
                </div>
            )}
        </div>
    )
}